import Vue from 'vue'
import store from '@/store'
export default {
	data() {
		return {
			headerShow: localStorage.getItem('headerShow') == 'false' ? false : true || true
		}
	},
	watch: {
		nowVibe() {
			if (this.nowVibe == 'pc') {
				if (window.innerWidth >= 1200) {
					this.headerShow = true;
					localStorage.setItem('headerShow', this.headerShow);
				} else {
					this.headerShow = false;
					localStorage.setItem('headerShow', this.headerShow);
				}
			} else {
				if (window.screen.width >= 1200) {
					this.headerShow = true;
					localStorage.setItem('headerShow', this.headerShow);
				} else {
					this.headerShow = false;
					localStorage.setItem('headerShow', this.headerShow);
				}
			}
		}
	},
	computed: {
		nowVibe() {
			return store.state.nowVibe
		},
		yhShow() {
			return store.state.yhShow
		}
	},
	created() {
		let loc= window.location.pathname.indexOf('/cn') === 0 ? 'zh' : 'en';
		if (!this.headerShow) {
			if (!this.yhShow) {
				this.$nextTick(function() {
					store.commit('yhShowSet', true)
					let t = this;
					// this.$alert(loc=='zh'?'澳华内镜欢迎你':'Welcome to Aohua Endoscopy', '', {
					// 	confirmButtonText:loc=='zh'?'确定':'OK',
					// 	callback: action => {
					// 		this.$nextTick(function() {
					// 			t.$bus.$emit('overLoad')
					// 		})
					// 	}
					// });
				})
			}
		}
	},
	mounted() {
		let t = this;
		t.$bus.$on('overLoad', function() {
			console.log("出发了刷新视频函数")
			// 获取页面上的所有视频元素
			let videos = document.getElementsByTagName('video');
			// 循环遍历每个视频元素
			for (let i = 0; i < videos.length; i++) {
				// 播放当前视频
				if (videos[i].id == 'vjs_video_3_html5_api') {
					let videoPlayer = this.$refs['videoPlayer' + this.activeIndex][0].$el;
					videoPlayer.play();
				} else {
					videos[i].play();
				}
			}
		})
		if (!this.headerShow) {
			this.$nextTick(function() {
				let videos = document.getElementsByTagName('video');
				// 循环遍历每个视频元素
				for (let i = 0; i < videos.length; i++) {
					// 播放当前视频
					if (videos[i].id == 'vjs_video_3_html5_api') {
						try{
							let videoPlayer = this.$refs['videoPlayer' + this.activeIndex][0].$el;
							videoPlayer.play();
						}catch(e){
							//TODO handle the exception
						}

					} else {
						
						videos[i].play();
					}
				}
			})
		}
	},
	methods: {
		goSetHeader() {
			if (this.nowVibe == 'pc') {
				if (window.innerWidth >= 1200) {
					this.headerShow = true;
					localStorage.setItem('headerShow', this.headerShow);
				} else {
					this.headerShow = false;
					localStorage.setItem('headerShow', this.headerShow);
				}
			} else {
				if (window.screen.width >= 1200) {
					this.headerShow = true;
					localStorage.setItem('headerShow', this.headerShow);
				} else {
					this.headerShow = false;
					localStorage.setItem('headerShow', this.headerShow);
				}
			}
		}
	}

}